import { useMemo, useState } from "react";

export const useCalendarView = ({ availability = [] }) => {
  const [currentDate, setCurrentDate] = useState(new Date());

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth(); // 0-based

  const availabilityMap = useMemo(() => {
    return Object.fromEntries(availability.map((item) => [item.date, item]));
  }, [availability]);

  const firstDayOfMonth = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const goToPrevMonth = () => {
    setCurrentDate(new Date(year, month - 1, 1));
  };

  const goToNextMonth = () => {
    setCurrentDate(new Date(year, month + 1, 1));
  };

  const calendarDays = useMemo(() => {
    const days = [];

    // Empty leading cells
    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push({ type: "empty" });
    }

    // Month days
    for (let day = 1; day <= daysInMonth; day++) {
      const dateKey = `${year}-${String(month + 1).padStart(2, "0")}-${String(
        day,
      ).padStart(2, "0")}`;

      days.push({
        type: "day",
        day,
        date: dateKey,
        availability: availabilityMap[dateKey],
      });
    }

    return days;
  }, [firstDayOfMonth, daysInMonth, availabilityMap, year, month]);

  return {
    year,
    month,
    monthLabel: currentDate.toLocaleString("default", {
      month: "long",
      year: "numeric",
    }),
    calendarDays,
    goToPrevMonth,
    goToNextMonth,
  };
};
